import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
  AllCollectionPointDetails,
  getCollectionPointsById,
  AllCollectionPointTypeDetails,
} from "../../Apis/collectionPointsApi";
import {
  GetZone,
  GetWard,
  GetCircle,
  GetCirclebyID,
  GetWardsbyCircleId,
} from "../../Apis/organizationApi";
import { AllShiftMaster } from "../../Apis/shiftMasterApi";
import TableComponent from "../../Common/TableComponent/tableComponent";
import { TableLoader } from "../../Common/ShimmerLoader";
import { useNavigate } from "react-router-dom";
import { withTranslation } from "react-i18next";
import * as XLSX from "xlsx";
import ExcelJS from "exceljs";
import imageCompression from "browser-image-compression";
import { saveAs } from "file-saver";
import JSZip from "jszip";
import { jsPDF } from "jspdf";
import QRCode from "qrcode-svg";
import "leaflet/dist/leaflet.css";
// Using public folder paths for images
import isGHMC from "../../Common/helper/helpar";
import AddCollectionPoint from "./AddCollectionPoint";
import AddQRCodeModal from "./addQrCodeModal";
import ExportMenu from "../../Common/ExportMenu/ExportMenu";
const logoLSD = "/assets/media/image/logo-LSD.png";
const logoLMC = "/assets/media/image/LMC-LOGO.jpg";

const GvpMaster = ({ t }) => {
  const headers = [
    "routePointName",
    "routePointType",
    "routePointCode",
    "routeCode",
    "routeName",
    "zone",
    "ward",
    "latitude",
    "longitude",
    "shiftA",
    "shiftB",
    "shiftC",
    "qrCode",
    "status",
    "actions",
  ];
  const isProd = isGHMC();
  const navigate = useNavigate();
  const [lgShow, setLgShow] = useState(false);
  const [fetchDataLoaded, setFetchDataLoaded] = useState(false);
  const [collectionPointDetails, setCollectionPointDetails] = useState([]);
  const [collectionDetails, setCollectionDetails] = useState([]);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [allZones, setAllZones] = useState([]);
  const [allCircles, setAllCircles] = useState([]);
  const [allWards, setAllWards] = useState([]);
  const [isCollectionLoading, setIsCollectionLoading] = useState(true);
  const [circleFetchError, setCircleFetchError] = useState(null);
  const [editCollectionDetails, setEditCollectionDetails] = useState("");
  const [edit, setEdit] = useState(false);
  const [selectedZone, setSelectedZone] = useState("");
  const [shiftData, setShiftData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [collectionPointTypes, setCollectionPointTypes] = useState([]);
  const [sortedData, setSortedData] = useState([]);
  const [excelData, setExcelData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [sortConfig, setSortConfig] = useState(null);
  const [selectedCircle, setSelectedCircle] = useState("");
  const [loadingCircles, setLoadingCircles] = useState(false);
  const [circles, setCircles] = useState([]);
  const [loadingWards, setLoadingWards] = useState(false);
  const [collectionImageName, setCollectionImageName] = useState("");
  const [imagePreview, setImagePreview] = useState(null);
  const [qrOpen, setQROpen] = useState(false);
  const [isActive, setIsActive] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [zoneId, setZoneId] = useState();
  const center = {
    lat: 17.452555,
    lng: 78.3599819,
  };
  const [formInput, setFormInput] = useState({
    collectionTypeId: "",
    collectionPointId: "",
    zoneId: "",
    circleId: "",
    wardId: "",
    collectionPointName: "",
    latitude: center.lat,
    longitude: center.lng,
    shiftId: "",
    collectionPointCode: "",
    routeCode: "", // Added for Route Code filter
    routeName: "", // Added for Route Name filter
    landmark: "",
    ShiftA: null,
    ShiftB: null,
    ShiftC: null,
    isActive: true,
    ImageUrl: "",
  });
  const libraries = ["places"];
  const [
    selectedCollectionPointCoordinates,
    setSelectedCollectionPointCoordinates,
  ] = useState(center);

  useEffect(() => {
    fetchCollectionPointTypes();
    fetchAllCollectionData();
  }, []);

  const fetchCollectionPointTypes = async () => {
    try {
      const response = await AllCollectionPointTypeDetails();
      setCollectionPointTypes(response);
    } catch (error) {
      console.error("Error fetching collection point types:", error);
    }
  };

  const handleClose = async () => {
    setEdit(false);
    setEditCollectionDetails(null);
    setLgShow(false);
    setFormSubmitted(false);
    setAllCircles([]);
    setAllWards([]);
  };

  const handleShow = () => {
    setLgShow(true);
    setEdit(false);
    setEditCollectionDetails(null);
    setImagePreview(null);
  };

  const handleEditCollectionDetails = (selectedData) => {
    setEditCollectionDetails(selectedData);
    setEdit(true);
    fetchCirclesData(selectedData.zoneId)
      .then(() => {
        fetchWardsData(selectedData.zoneId, selectedData.circleId);
      })
      .catch((error) => {
        console.error("Error fetching circles and wards:", error);
      });
    setLgShow(true);
  };

  const handleCircleChange = async (circleId) => {
    setFormInput((prevData) => ({
      ...prevData,
      circleId: circleId,
      wardId: "",
    }));
    try {
      const wardsData = await GetWardsbyCircleId(circleId);
      setAllWards(wardsData);
    } catch (error) {
      console.error("Error fetching wards data:", error);
    }
  };

  useEffect(() => {
    if (formInput.circleId) {
      fetchWardsData(formInput.zoneId, formInput.circleId);
      setFormInput((prevData) => ({
        ...prevData,
        wardId: formInput.wardId,
      }));
    }
    if (formInput.zoneId) {
      fetchCirclesData(formInput.zoneId);
    }
  }, [formInput.circleId, formInput.zoneId]);

  const fetchWardsData = async (zoneId, circleId) => {
    try {
      const response = await GetWardsbyCircleId(circleId);
      setAllWards(response);
    } catch (error) {
      console.error("Error fetching wards data:", error);
    }
  };

  const fetchAllCollectionData = async () => {
    try {
      setIsCollectionLoading(true);
      const collectionPointsData = await AllCollectionPointDetails();
      setCollectionPointDetails(collectionPointsData);
      setFetchDataLoaded(true);
    } catch (error) {
      console.error("Error fetching initial data:", error);
    } finally {
      setIsCollectionLoading(false);
    }
  };

  const fetchAllDataDetails = async () => {
    try {
      const zonesData = await GetZone();
      const delhiZones = (Array.isArray(zonesData) ? zonesData : []).filter(
        (zone) =>
          zone.isActive
      );
      setAllZones(delhiZones);
      if (selectedZone) {
        const circlesData = await GetCirclebyID(selectedZone);
        setAllCircles(circlesData);
      } else {
        setAllCircles([]);
      }
    } catch (error) {
      console.error("Error fetching initial data:", error);
    }
  };

  useEffect(() => {
    fetchAllDataDetails();
  }, []);

  useEffect(() => {
    if (allZones.length === 0) return;

    setFormInput((previous) => {
      if (previous.zoneId) return previous;
      return { ...previous, zoneId: allZones[0].zoneId };
    });
  }, [allZones]);

  useEffect(() => {
    const fetchShiftData = async () => {
      try {
        setIsLoading(true);
        const shiftDataResponse = await AllShiftMaster();
        setShiftData(shiftDataResponse);
      } catch (error) {
        console.error("Error fetching shift data:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchShiftData();
  }, []);

  useEffect(() => {
    if (selectedZone) {
      const fetchCirclesData = async () => {
        try {
          const circlesData = await GetCirclebyID(selectedZone);
          setAllCircles(circlesData.data);
        } catch (error) {
          console.error("Error fetching circles data:", error);
        }
      };
      fetchCirclesData();
    } else {
      setAllCircles([]);
    }
  }, [selectedZone]);

  useEffect(() => {
    if (selectedZone) {
      setAllCircles([]);
      setAllWards([]);
    }
  }, [selectedZone]);

  const handleViewCollectionPoints = async (id) => {
    try {
      const response = await getCollectionPointsById(id);
      const collectionPointDetails = response.data.data;
      navigate("/view-collection-points-details", {
        state: { collectionPointDetails },
      });
    } catch (error) {
      console.error(error);
    }
  };

  const fetchAllCollectionPointDetails = async () => {
    const {
      zoneId,
      circleId,
      wardId,
      shiftId,
      collectionPointCode,
      collectionTypeId,
      routeCode,
      routeName,
    } = formInput;

    try {
      setIsLoading(true);
      const isActiveFilter = isActive !== "" ? isActive : null;
      const [
        collectionPointDetails,
        wardNameResponse,
        zoneNameResponse,
        circleNameResponse,
      ] = await Promise.all([
        AllCollectionPointDetails({
          zoneId: zoneId || null,
          circleId: circleId || null,
          wardId: wardId || null,
          shift: shiftId || null,
          isActive: isActiveFilter,
          collectionPointCode: collectionPointCode,
          CollectionPointTypeId: collectionTypeId,
          routeCode: routeCode || null, // Added
          routeName: routeName || null, // Added
        }),
        GetWard(),
        GetZone(),
        GetCircle(),
      ]);

      const collectionPointData = collectionPointDetails.map((station) => {
        const ward = wardNameResponse.find(
          (ward) => ward.wardId === station.wardId
        );
        const zone = zoneNameResponse.find(
          (zone) => zone.zoneId === station.zoneId
        );
        const circle = circleNameResponse.find(
          (circle) => circle.circleId === station.circleId
        );
        return {
          ...station,
          routePointName: station.collectionPointName,
          zone: zone ? zone.zoneName : "N/A",
          ward: circle ? circle.circleName : "N/A",
          routePointType: station.collectionPointTypeName || "N/A",
          routePoint: station.collectionPointName || "N/A",
          routeName: station.routeName || "N/A",
          routeCode: station.routeCode || "N/A",
          routePointCode: station.collectionPointCode || "N/A",
          status: station.isActive ? "Active" : "InActive",
        };
      });

      const sortedCollectionPointsData = collectionPointData.sort((a, b) => {
        if (a.isActive === b.isActive) {
          return 0;
        }
        return a.isActive ? -1 : 1;
      });

      setCollectionDetails(sortedCollectionPointsData);
      setOriginalData(collectionPointData);
      setFilteredData(sortedCollectionPointsData);
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching collection point details:", error);
    }
  };

  useEffect(() => {
    fetchAllCollectionPointDetails();
  }, []);

  const options = { day: "numeric", month: "numeric", year: "numeric" };
  const generationTime = ` ${new Date()
    .toLocaleString("en-GB", options)
    .replace(/\//g, "/")}`;

  const downloadAsExcel = async (dataToUse) => {
    const currentDate = new Date();
    const formattedDate = `${currentDate.getDate()}/${currentDate.getMonth() + 1}/${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const downloadDateTime = `Route Point Report Generated on: ${formattedDate}, ${formattedTime}`;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Route Points");

    const boldFont = { bold: true };

    worksheet.addRow(["", "", downloadDateTime, ""]);
    worksheet.mergeCells(1, 2, 1, 12);
    worksheet.getCell(1, 2).value = downloadDateTime;
    worksheet.getCell(1, 2).font = boldFont;
    worksheet.getCell(1, 2).alignment = { horizontal: "center" };

    for (let col = 2; col <= 12; col++) {
      worksheet.getCell(1, col).font = boldFont;
      worksheet.getCell(1, col).alignment = { horizontal: "center" };
    }

    worksheet.addRow(["", "", "Route Points", ""]);
    worksheet.mergeCells(2, 2, 2, 12);
    worksheet.getCell(2, 2).value = "Route Point Details";
    worksheet.getCell(2, 2).font = boldFont;
    worksheet.getCell(2, 2).alignment = { horizontal: "center" };

    for (let col = 2; col <= 14; col++) {
      worksheet.getCell(2, col).font = boldFont;
      worksheet.getCell(2, col).alignment = { horizontal: "center" };
    }

    worksheet.addRow([""]);

    const tableHeaderRow = worksheet.addRow([
      "S.No",
      "Route Point Name",
      "Route Point Type",
      "Route Point Code",
      "Route Code",
      "Route Name",
      "Zone",
      "Ward",
      "Latitude",
      "Longitude",
      "Shift A",
      "Shift B",
      "Shift C",
      "Status",
    ]);

    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
      cell.alignment = { horizontal: "left" };
      if (colNumber >= 1 && colNumber <= 14) {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "003366" },
        };
      }
    });

    dataToUse.forEach((item, index) => {
      worksheet.addRow([
        index + 1,
        item.collectionPointName,
        item.collectionPointTypeName,
        item.collectionPointCode,
        item.routeCode,
        item.routeName,
        item.zone,
        item.circleName,
        item.latitude,
        item.longitude,
        item.shiftA ? true : false,
        item.shiftB ? true : false,
        item.shiftC ? true : false,
        item.status,
      ]).eachCell({ includeEmpty: true }, (cell) => {
        cell.alignment = { horizontal: "left" };
      });
    });

    worksheet.columns = [
      { width: 5 },
      { width: 25 },
      { width: 25 },
      { width: 20 },
      { width: 20 },
         { width: 20 },
      { width: 15 },
      { width: 15 },
      { width: 15 },
      { width: 10 },
      { width: 10 },
      { width: 10 },
      { width: 20 },
    ];

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "RoutePointDetails.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };

  let storedPermissions = localStorage.getItem("permissionId");
  const permissionValues1 =
    JSON.parse(localStorage.getItem("rolePermissions")) || {};
  let canWriteValue = null;

  storedPermissions = parseInt(storedPermissions, 10);

  const matchingPermission = permissionValues1.find(
    (mapping) => mapping.permissionId === storedPermissions
  );

  if (matchingPermission) {
    canWriteValue = matchingPermission.canWrite;
  } else {
    console.log(`No match found for permission ID ${storedPermissions}`);
  }

  const handleDownloadQRCode = async () => {
    const zip = new JSZip();
    const qrSize = 1024;

    // Always download all QR codes from collectionDetails
    const allItems = collectionDetails.filter(item => item.qrCodeValue?.trim() !== "");
    
    console.log("Downloading all QR codes:", allItems.length);
    
    if (!allItems || allItems.length === 0) {
      toast.error("No QR codes available to download.");
      return;
    }

    const promises = allItems.map((item, index) => {
      console.log(`Processing item ${index + 1}:`, item);
      return new Promise((resolve, reject) => {
        const qr = new QRCode({
          content: item.qrCodeValue,
          padding: 4,
          width: qrSize,
          height: qrSize,
          color: "#000000",
          background: "#ffffff",
          ecl: "M",
        });

        const svg = qr.svg();
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        const img = new Image();

        img.onload = () => {
          canvas.width = qrSize;
          canvas.height = qrSize;
          ctx.drawImage(img, 0, 0, qrSize, qrSize);
          const imgData = canvas.toDataURL("image/jpeg", 1.0);
          
          // Custom paper size - tall format
          const pdf = new jsPDF("p", "mm", [90, 250]);
          const pageWidth = pdf.internal.pageSize.getWidth();
          const pageHeight = pdf.internal.pageSize.getHeight();

          // Load first logo (LSD logo)
          const logo1 = new Image();
          logo1.src = logoLSD;
          logo1.crossOrigin = "anonymous";

          // Load second logo (LMC logo)
          const logo2 = new Image();
          logo2.src = logoLMC;
          logo2.crossOrigin = "anonymous";

          logo1.onload = () => {
            logo2.onload = () => {
              // === Header with light beige background ===
              pdf.setFillColor(255, 230, 174); // Light beige color
              pdf.rect(0, 0, pageWidth, 18, 'F');
              
              // Add left logo with space
              pdf.addImage(logo1, 'PNG', 5, 3, 12, 12);
              
              // Add right logo with space
              pdf.addImage(logo2, 'PNG', pageWidth - 17, 3, 12, 12);

              // Main title in dark red
              pdf.setFont('helvetica', 'bold');
              pdf.setTextColor(153, 0, 0); // Dark red color
              pdf.setFontSize(7);
              pdf.text('Central Delhi Solid Waste Management', pageWidth / 2, 9, { align: 'center' });

              // Subtitle in black
              pdf.setFontSize(6);
              pdf.setTextColor(0, 0, 0);
              pdf.text('Central Delhi Solid Waste Management', pageWidth / 2, 14, { align: 'center' });

              // === QR Code in center - large size ===
              const qrWidthMM = 65; // Large QR code to match image
              const qrX = (pageWidth - qrWidthMM) / 2;
              const qrY = 18; // Positioned directly below header with no gap
              pdf.addImage(imgData, 'JPEG', qrX, qrY, qrWidthMM, qrWidthMM);

              // ==== Labels and Values ====
              const labels = [
                "ROUTE POINT:",
                "ROUTE NAME:",
                "ZONE:",
                "WARD:",
                "UID:"
              ];
              const values = [
                item.routePointName || "-",
                item.routeName || "-", 
                item.zoneName || "-",
                item.circleName || "-",
                item.qrCodeValue || "-"
              ];

              // Create table with thin borders - narrow and centered, directly below QR code
              const tableY = qrY + qrWidthMM + 0;
              const rowHeight = 6;
              const tableWidth = 70; // Narrow table width
              const tableX = (pageWidth - tableWidth) / 2; // Center the table
              const labelWidth = 35; // Width for label column
              const valueWidth = tableWidth - labelWidth; // Width for value column

              // Thin gray borders
              pdf.setDrawColor(200, 200, 200); // Light gray color for borders
              pdf.setLineWidth(0.2); // Thin line

              for (let i = 0; i < labels.length; i++) {
                const y = tableY + i * rowHeight;
                
                // Draw table border for each row (thin gray border)
                pdf.rect(tableX, y, tableWidth, rowHeight);
                
                // Draw vertical line to separate label and value columns
                pdf.line(tableX + labelWidth, y, tableX + labelWidth, y + rowHeight);
                
                // Add label in left column - bold, black, left-aligned
                pdf.setFont('helvetica', 'bold');
                pdf.setFontSize(5.5);
                pdf.setTextColor(0, 0, 0); // Black text
                pdf.text(labels[i], tableX + 2, y + 4);
                
                // Add value in right column - bold, black, left-aligned
                pdf.setFont('helvetica', 'bold');
                pdf.setFontSize(5.5);
                pdf.setTextColor(0, 0, 0); // Black text
                pdf.text(values[i], tableX + labelWidth + 2, y + 4);
              }

              // Footer - smaller font
              pdf.setFontSize(2);
              pdf.setTextColor(100);
              pdf.setFont("helvetica", "normal");
              // pdf.text("Powered by VMax e-Solutions India Pvt Limited", pageWidth / 2, pageHeight - 1, { align: "center" });

              // Add to zip
              const pdfBlob = pdf.output("blob");
              zip.file(`${index + 1}_${item.routePointName || "QRCode"}.pdf`, pdfBlob);
              resolve();
            };
            logo2.onerror = reject;
          };
          logo1.onerror = reject;
        };
        img.onerror = reject;
        img.src = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
      });
    });

    try {
      await Promise.all(promises);
      const content = await zip.generateAsync({ type: "blob" });
      saveAs(content, "all_route_point_qrcodes.zip");
      toast.success(`ZIP file with ${allItems.length} QR codes downloaded successfully.`);
      console.log("ZIP file with PDFs generated and downloaded successfully.");
    } catch (error) {
      console.error("Error generating or downloading ZIP file:", error);
      toast.error("Error downloading QR codes. Please try again.");
    }
  };

  const handleSort = async (config) => {
    const sortedArray = [...collectionDetails].sort((a, b) => {
      const aField = a[config.key];
      const bField = b[config.key];
      if (aField < bField) return config.direction === "ascending" ? -1 : 1;
      if (aField > bField) return config.direction === "ascending" ? 1 : -1;
      return 0;
    });
    setSortedData(sortedArray);
  };

  const handleSortAndExport = async () => {
    if (sortConfig) {
      await handleSort(sortConfig);
    }
    const dataToExport =
      sortedData && sortedData.length > 0
        ? sortedData
        : filteredData.length > 0
        ? filteredData
        : originalData;
    downloadAsExcel(dataToExport);
  };

  const handleZoneChange = async (zoneId) => {
    setFormInput((prevData) => ({
      ...prevData,
      zoneId: zoneId,
      circleId: "",
    }));
    setSelectedCircle("");
    if (zoneId) {
      fetchCirclesData(zoneId);
    } else {
      setCircles([]);
      setAllWards([]);
    }
  };

  const fetchCirclesData = async (zoneId) => {
    try {
      const response = await GetCirclebyID(zoneId);
      setCircles(response);
      setCircleFetchError(null);
    } catch (error) {
      console.error("Error fetching circles data:", error);
      setCircles([]);
      setCircleFetchError(
        error.response ? error.response.data.message : "Unknown error occurred"
      );
      toast.error(`Error fetching circles: ${circleFetchError}`);
    }
  };

  const handleShiftChange = (shift) => {
    const shiftId = shiftMapping[shift] || null;
    setFormInput((prevData) => ({
      ...prevData,
      shiftId,
    }));
  };

  const handleCollectionTypeChange = (e) => {
    const collectionTypeId = e.target.value;
    setFormInput((prevData) => ({
      ...prevData,
      collectionTypeId,
    }));
  };

  const shiftMapping = {
    shiftA: 1,
    shiftB: 2,
    shiftC: 3,
  };

  const handleActiveChange = (status) => {
    const mappedStatus =
      status === "true" ? true : status === "false" ? false : "";
    setIsActive(mappedStatus);
  };

  const handleOpenDownloadQRModal = () => {
    setQROpen(true);
  };

  const handleQRClose = () => {
    setQROpen(false);
  };

  return (
    <>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <div className="top-header page-title">
              <span>{t("Route Point Details")}</span>
            </div>
            <div className="page-header my-2">
              <div className="vehicle-button my-2 align-items-center gap-2">
                {/* {canWriteValue === true ? (
                  <button className="button-container" onClick={handleShow}>
                    <i className="fa-solid fa-plus me-1 icon-container"></i>
                    {t("Add Route Point")}
                  </button>
                ) : (
                  ""
                )} */}
                <button
                  className="btn btn-excel"
                  onClick={handleOpenDownloadQRModal}
                >
                  Generate QR Codes For Route Points
                </button>
                <ExportMenu
                  items={[
                    {
                      label: "Excel",
                      icon: "fa-solid fa-file-excel",
                      onClick: handleSortAndExport,
                    },
                    {
                      label: "Download QR",
                      icon: "fa-regular fa-file-pdf",
                      onClick: handleDownloadQRCode,
                    },
                  ]}
                />
              </div>
            </div>
            <div className="">
              <div className="page-header-left">
                <div className="row align-items-end">
                  <div className="col-md-12">
                    <div className="row g-2">
                      <div className="col mb-3">
                        <div className="form-group-filter">
                          <label className="form-label small mb-1">Route Point Code</label>
                          <input
                            type="text"
                            name="collectionPointCode"
                            className="bg-white"
                            style={FilterinputStyle}
                            placeholder="Route Point Code"
                            value={formInput.collectionPointCode}
                            onChange={(e) =>
                              setFormInput((prevData) => ({
                                ...prevData,
                                collectionPointCode: e.target.value,
                              }))
                            }
                          />
                        </div>
                      </div>
                      <div className="col mb-3">
                        <div className="form-group-filter">
                          <label className="form-label small mb-1">Route Code</label>
                          <input
                            type="text"
                            name="routeCode"
                            className="bg-white"
                            style={FilterinputStyle}
                            placeholder="Route Code"
                            value={formInput.routeCode}
                            onChange={(e) =>
                              setFormInput((prevData) => ({
                                ...prevData,
                                routeCode: e.target.value,
                              }))
                            }
                          />
                        </div>
                      </div>
                      <div className="col mb-3">
                        <div className="form-group-filter">
                          <label className="form-label small mb-1">Route Name</label>
                          <input
                            type="text"
                            name="routeName"
                            className="bg-white"
                            style={FilterinputStyle}
                            placeholder="Route Name"
                            value={formInput.routeName}
                            onChange={(e) =>
                              setFormInput((prevData) => ({
                                ...prevData,
                                routeName: e.target.value,
                              }))
                            }
                          />
                        </div>
                      </div>
                      <div className="col mb-3">
                        <div className="form-group-filter">
                          <label className="form-label small mb-1">Route Point Type</label>
                          <select
                            value={formInput.collectionTypeId || ""}
                            id="vehicle-filter-input"
                            name="collectionTypeId"
                            className={`form-select ${
                              formInput.collectionTypeId || !formSubmitted
                                ? ""
                                : "input-error"
                            }`}
                            onChange={handleCollectionTypeChange}
                          >
                            <option value="">Select</option>
                            {collectionPointTypes.map((collectionPoint) => (
                              <option
                                value={collectionPoint.collectionPointTypeId}
                                key={collectionPoint.collectionPointTypeId}
                              >
                                {collectionPoint.collectionPointTypeName}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div className="col mb-3">
                        <div className="form-group-filter">
                          <label className="form-label small mb-1">Zone</label>
                          <select
                            value={formInput.zoneId}
                            id="vehicle-filter-input"
                            name="zoneId"
                            className={`form-select ${
                              formInput.zoneId || !formSubmitted
                                ? ""
                                : "input-error"
                            }`}
                            onChange={(e) => handleZoneChange(e.target.value)}
                          >
                            {allZones.map((zone) => (
                              <option key={zone.zoneId} value={zone.zoneId}>
                                {zone.zoneName}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div className="col mb-3">
                        <div className="form-group-filter">
                          <label className="form-label small mb-1">Ward</label>
                          <select
                            className={`form-select ${
                              formInput.circleId || !formSubmitted
                                ? ""
                                : "input-error"
                            }`}
                            name="circleId"
                            id="vehicle-filter-input"
                            value={formInput.circleId}
                            onChange={(e) => {
                              setFormInput((prevData) => ({
                                ...prevData,
                                circleId: e.target.value,
                              }));
                              handleCircleChange(e.target.value);
                            }}
                          >
                            <option value="">Select</option>
                            {formInput.zoneId ? (
                              loadingCircles ? (
                                <option>Loading Wards...</option>
                              ) : circles.length > 0 ? (
                                circles
                                  .filter((circle) => circle.isActive)
                                  .map((circle) => (
                                    <option
                                      key={circle.circleId}
                                      value={circle.circleId}
                                    >
                                      {circle.circleName.split(" [")[0]}
                                    </option>
                                  ))
                              ) : (
                                <option value="" disabled>
                                  No Wards found
                                </option>
                              )
                            ) : null}
                          </select>
                          {!formInput.circleId && formSubmitted && (
                            <div className="required-message">
                              Ward is Required
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col mb-3">
                        <div className="form-group-filter">
                          <label className="form-label small mb-1">Shift</label>
                          <select
                            value={formInput.shiftId}
                            id="vehicle-filter-input"
                            name="shift"
                            className={`form-select ${
                              formInput.shiftId || !formSubmitted
                                ? ""
                                : "input-error"
                            }`}
                            onChange={(e) => handleShiftChange(e.target.value)}
                          >
                            <option value="">Select</option>
                            <option value="shiftA">Shift A</option>
                            <option value="shiftB">Shift B</option>
                            <option value="shiftC">Shift C</option>
                          </select>
                        </div>
                      </div>
                      <div className="col mb-3">
                        <div className="form-group-filter">
                          <label className="form-label small mb-1">Status</label>
                          <select
                            value={
                              isActive === true
                                ? "true"
                                : isActive === false
                                ? "false"
                                : ""
                            }
                            id="vehicle-filter-input"
                            name="isActive"
                            className={`form-select ${
                              isActive === "" && !formSubmitted
                                ? "input-error"
                                : ""
                            }`}
                            onChange={(e) => handleActiveChange(e.target.value)}
                          >
                            <option value="true">Active</option>
                            <option value="false">InActive</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12 mb-3 d-flex justify-content-end">
                    <button
                      type="button"
                      className={`btn search ${
                        isProd ? "search-ghmc" : "search-swm"
                      }`}
                      onClick={fetchAllCollectionPointDetails}
                    >
                      Search
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="card">
              <div className="">
                {isCollectionLoading ? (
                  <TableLoader height={500} />
                ) : (
                  <TableComponent isLoading={isLoading}
                    DataFetchURL={collectionDetails}
                    headers={headers}
                    filterFunction={(data) =>
                      data.filter(
                        (item) => item.status === 1 || item.status === 2
                      )
                    }
                    editData={handleEditCollectionDetails}
                    editDataDetails={editCollectionDetails}
                    viewData={(id) => handleViewCollectionPoints(id)}
                    onSort={handleSort}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <AddQRCodeModal
        open={qrOpen}
        handleClose={handleQRClose}
      />
      <Modal
        size="lg"
        show={lgShow}
        onHide={() => handleClose()}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header>
          <Modal.Title>
            {editCollectionDetails ? t("editCollection") : t("addCollection")}
          </Modal.Title>
          <i
            className="fa-solid fa-xmark close-container"
            onClick={handleClose}
          ></i>
        </Modal.Header>
        <hr />
        <Modal.Body>
          <AddCollectionPoint
            editCollectionDetails={editCollectionDetails}
            edit={edit}
            setEdit={setEdit}
            handleViewCollectionPoints={handleViewCollectionPoints}
            fetchAllCollectionPointDetails={fetchAllCollectionPointDetails}
            setLgShow={setLgShow}
            editPermission={canWriteValue}
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

const FilterinputStyle = {
  height: "38px",
  borderRadius: "4px",
  border: "1px solid #ced4da",
  paddingLeft: "10px",
  width: "100%",
  backgroundColor: "white",
};

export default withTranslation()(GvpMaster);